export const SURFACE_MOTION_CLASS =
  'data-[state=open]:animate-fade-in data-[state=closed]:animate-fade-out data-[state=delayed-open]:animate-fade-in data-[state=instant-open]:animate-fade-in data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=delayed-open]:fade-in-0 data-[state=instant-open]:fade-in-0 duration-200 ease-out-quint [will-change:opacity]'

export const OVERLAY_MOTION_CLASS =
  'data-[state=open]:animate-fade-in data-[state=closed]:animate-fade-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 duration-200 ease-out-quint [will-change:opacity]'

export const DATA_SURFACE_MOTION_CLASS =
  'data-open:animate-fade-in data-closed:animate-fade-out data-closed:fade-out-0 data-open:fade-in-0 duration-200 ease-out-quint [will-change:opacity]'

export const DATA_OVERLAY_MOTION_CLASS =
  'data-open:animate-fade-in data-closed:animate-fade-out data-closed:fade-out-0 data-open:fade-in-0 duration-200 ease-out-quint [will-change:opacity]'
